type Props = {
  rows: number;
  totalBS: string;
  totalFS: string;
  closureError: string;
  closureStatus: string;
};

export default function SummaryCards({
  rows,
  totalBS,
  totalFS,
  closureError,
  closureStatus,
}: Props) {
  return (
    <div className="summary">
      <div><span>Rows</span><b>{rows}</b></div>
      <div><span>Total BS</span><b>{totalBS}</b></div>
      <div><span>Total FS</span><b>{totalFS}</b></div>
      <div><span>Closure Error</span><b>{closureError}</b></div>
      <div><span>Closure Status</span><b>{closureStatus}</b></div>
    </div>
  );
}
